import styled, { css } from 'styled-components'

import { HeightClass } from '~/utils/enum/classes'

import Icon from '../../Icon'

export const OptionsList = styled.ul<{ heightClass: HeightClass }>`
  list-style: none;
  padding: 0;
  margin: 0;
  background: #ffffff;
  border: 2px solid;
  border-color: ${({ theme }) => theme.colors.cyanBlueInputBorder};
  border-radius: 4px;
  position: absolute;
  left: 0;
  top: 100%;
  z-index: 1;
  width: 100%;
  max-height: 25rem;

  min-height: ${({ theme, heightClass }) =>
    `${
      (theme.input[heightClass]?.lineHeight || 0) +
      (theme.input[heightClass]?.paddingY || 0) * 2
    }px`};

  overflow-y: auto;

  &[aria-busy='true'] {
    border-color: ${({ theme }) => theme.colors.naplesYellow};
  }

  ::-webkit-scrollbar {
    width: 6px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 100px;
    background-color: #abbed1;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 100px;
    margin: 10px;
    background-color: transparent;
    border: 1px solid #abbed1;
  }
`

export const OptionsListItem = styled.li<{
  heightClass: HeightClass
  collapsable?: boolean
  uniselection?: boolean
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.barlow};
  font-style: normal;
  font-weight: 400;

  ${({ theme, heightClass }) => css`
    font-size: ${theme.input[heightClass]?.fontSize}px;

    padding: ${theme.input[heightClass]?.paddingY}px
      ${theme.input[heightClass]?.paddingX}px;
  `}

  color: #303032;

  cursor: pointer;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;

  &[aria-selected='true']:not([data-active='true']) {
    background: ${({ theme }) => theme.colors._CCE1FF};
  }

  &[data-active='true'],
  [aria-busy='false'] &:hover {
    background: ${({ theme }) => theme.colors._006BFF};
    color: ${({ theme }) => theme.colors.white};
  }

  ${({ collapsable, theme }) =>
    collapsable &&
    css`
      background: ${({ theme }) => theme.colors._CCE1FF};
      font-weight: 600;
      border-bottom: 2px solid;
      border-color: ${theme.colors.cyanBlueInputBorder};
    `}
`

export const MiniArrowIcon = styled(Icon)<{ collapsed?: boolean }>`
  transform: ${({ collapsed }) => (collapsed ? 'rotate(180deg)' : 'rotate(0)')};
`
